/* jshint browser:true */

/**
 * Applies fade-up effect when elements scroll into view.
 */
export default class FadeupScroll {
  constructor() {
    this.classNames = {
      visible: 'fade-up-scroll--visible',
      delayPrefix: 'fade-up-scroll--delay-'
    };
  }

  /**
   * Initializes effect.
   * @param {string} selector CSS selector to find elements.
   */
  init(selector) {
    const wrappers = document.querySelectorAll(selector);

    if (!wrappers) {
      throw new ReferenceError(`No fade-up elements found for selector: ${selector}`);
    }

    wrappers.forEach(x => this.setup(x));
  }

  /**
   * Sets up an individual effect.
   * @param {HTMLElement} wrapper The root element to which the effect will be
   *        applied.
   */
  setup(wrapper) {
    const delay = this.getDelay(wrapper);
    const options = {
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            wrapper.classList.add(this.classNames.visible);
            observer.disconnect();
          }, delay);
        }
      });
    }, options);

    observer.observe(wrapper);
  }

  /**
   * Returns the amount of time (ms) that the effect should be delayed, as
   * determined by an HTML class.
   * @param {HTMLElement} wrapper The root element to which the effect will be
   *        applied.
   */
  getDelay(wrapper) {
    const classes = wrapper.className.split(' ');
    const delayClass = classes.find(x => x.includes(this.classNames.delayPrefix));

    if (!delayClass) {
      return 0;
    }

    const delayString = delayClass.replace(this.classNames.delayPrefix, '');

    return parseInt(delayString);
  }
}
